import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IGanttPeriod } from '../model/interfaces'
import dayjs from 'dayjs'
interface IGanttState {
  type: 'employee' | 'project'
  zoom: 'Hours' | 'Days' | 'Months'
  period: IGanttPeriod
}

const initialState: IGanttState = {
  type: 'employee',
  zoom: 'Months',
  period: {
    // start: dayjs().startOf('year').toDate(),
    // end: dayjs().endOf('year').toDate()
    start: dayjs().startOf('month').subtract(6, 'month').toDate(),
    end: dayjs().endOf('month').add(6, 'month').toDate()
  }
}
export const ganttSlice = createSlice({
  name: 'gantt',
  initialState,
  reducers: {
    setGanttType(state, { payload }: PayloadAction<'employee' | 'project'>) {
      state.type = payload
    },
    setGanttZoom(state, { payload }: PayloadAction<'Hours' | 'Days' | 'Months'>) {
      state.zoom = payload
    },
    setTmpGanttPeriod(state, { payload }: PayloadAction<IGanttPeriod>) {
      state.period = payload
    }
  }
})

export const ganttActions = ganttSlice.actions
export const ganttReducer = ganttSlice.reducer
